import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 24,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      networkMode: 'offlineFirst',
      retry(failureCount, error) {
        // Don't retry on 4xx errors except for 408, 429
        const status = (error as any)?.statusCode || (error as any)?.response?.status;

        if (status >= 400 && status < 500 && status !== 408 && status !== 429) {
          return false;
        }
        
        // Retry up to 3 times for other errors
        return failureCount < 3;
      },
    },
    mutations: {
      // We'll handle mutation errors individually in each mutation
    },
  },
});

export class MobilePersister {
  private static callback: any | null = null;
  
  static serialize(data: any) {
    const reactNativeWebView = (window as any)?.ReactNativeWebView;

    if (!reactNativeWebView) {
      return;
    }

    reactNativeWebView.postMessage(JSON.stringify({
      type: 'persistQuery',
      data,
    }));
  }

  static deserialize(stringData: string) {
    const data = JSON.parse(stringData);

    if (this.callback) {
      this.callback(data);
    }
  }

  static requestDeserialization() {
    const reactNativeWebView = (window as any)?.ReactNativeWebView;

    if (!reactNativeWebView) {
      return null;
    }

    reactNativeWebView.postMessage(JSON.stringify({
      type: 'requestQuery',
    }));

    return new Promise((res) => {
      this.callback = res;
    });  
  }

  static remove() {
    const reactNativeWebView = (window as any)?.ReactNativeWebView;

    if (!reactNativeWebView) {
      return;
    }

    reactNativeWebView.postMessage(JSON.stringify({
      type: 'removeQuery',
    }));
  }
}

export const customPersister = {
  async persistClient(client: any) {
    MobilePersister.serialize(client);
  },
  async restoreClient() {
    const client = await MobilePersister.requestDeserialization();

    return client;
  },
  async removeClient() {
    MobilePersister.remove();
  },
};